export const initialAppCodeForm = {
  appCode: "",
  url: "",
  id: null,
};

export const appCodeRules = [
  {
    field_name: "appCode",
    label: "App Code",
    type: "string",
    isRequired: true,
    noWhiteSpace: true,
  },
  {
    field_name: "url",
    label: "Url",
    type: "validUrl",
    isRequired: true,
  },
];
